import { useSelector } from 'react-redux'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { RATIO_INDICATOR_COL_ID } from '../../../store/helper'
import { selectCellData } from '../../../store/slice'
import CellWithSeparation from './CellWithSeparation'
import FirstColumnCell from './FirstColumnCell'
import RatioSelectedCell from './RatioSelectedCell'
import { isOdd } from './helper'

const withCustomTd = (config) => (Component) => (props) => {
  const { rowIndex, colIndex, rowId, colId, typePrefix, isDynamicReport } =
    config
  const val = useSelector(selectCellData(rowId, rowIndex, colId, typePrefix))

  const { unitName, currency, formatCurrency } = useFormatCurrency(
    SCREEN.PORTFOLIO_INSIGHTS_FINANCE,
  )

  if (rowIndex === 0 && colIndex === 0) {
    return (
      <FirstColumnCell
        {...props}
        val={val}
        unitName={unitName}
        currency={currency}
        isDynamicReport={isDynamicReport}
      />
    )
  }

  if (
    (rowIndex !== 0 && colIndex === 0) ||
    (isOdd(rowIndex) && colId === RATIO_INDICATOR_COL_ID)
  ) {
    return null
  }

  if (colId === RATIO_INDICATOR_COL_ID) {
    return <RatioSelectedCell {...props} val={val} />
  }

  if (isOdd(rowIndex) && colIndex !== 0) {
    return (
      <CellWithSeparation
        {...props}
        val={val}
        colId={colId}
        rowId={rowId}
        isDynamicReport={isDynamicReport}
        formatCurrency={formatCurrency}
      />
    )
  }

  return (
    <Component
      {...props}
      val={val}
      colId={colId}
      rowId={rowId}
      formatCurrency={formatCurrency}
      isDynamicReport={isDynamicReport}
    />
  )
}

export default withCustomTd
